<label [for]="title">{{ title }}</label>
<!-- <mat-progress-bar mode="determinate" [value]="skill"></mat-progress-bar> -->
<progress [id]="title" max="10" [value]="skill">{{ skill }}/10 </progress>
